import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import type { Market } from '@backmarket/http-api'

import { HELP_CENTER } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_INTERCOM_ROUTE_HELP_CENTER_BY_COUNTRY } =
    useRuntimeConfig().public

  const enableIntercom =
    FF_ENABLED_INTERCOM_ROUTE_HELP_CENTER_BY_COUNTRY?.includes(
      market.countryCode,
    )

  return [
    {
      name: HELP_CENTER.HOME,
      path: 'help',
      component: () => import('~/scopes/help-center/Home.vue'),
      meta: {
        auth: {
          required: false,
        },
        userLoadingStrategy: 'server',
        // Required because help-center components are shown/hidden depending on auth state. it prevents UI flashes on full-page reload
        intercom: {
          enableIntercom,
          launcher: true,
          loading: 'onPageLoad',
        },
        layout: false,
        owners: ['bot-squad-sales-customer-care-front'],
      },
    },
  ]
}
